/* @ngInject */
const sterileService = (
  sterileAsk,
  sterileFormat,
  sterileGo,
  sterileLocal,
  sterileRequest,
  sterileMetadata
) => {
  const self = {}

  self.ask = sterileAsk
  self.format = sterileFormat
  self.go = sterileGo
  self.local = sterileLocal
  self.request = sterileRequest
  self.metadata = sterileMetadata
  self.data = {}

  self.new = () => {
    return {
      name: null,
      weight: null,
    }
  }

  return self
}
export default sterileService



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/sterile.service.js